export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/preview/resources/data.js